<div class="p1-inline">
  <div class="button_container">
    <span>
      <dx-button icon="refresh" (click)="updateData()"></dx-button>
    </span>
    <span class="left">
      Show My Workspace:
      <dx-switch
        [value]="loaderService.showWorkspace()"
        (onValueChanged)="toggleWorkspace($event)"
      ></dx-switch>
    </span>
    @if (isCreateWorloadVisible) {
      <dx-button
        (onClick)="openCreateWorkload()"
        text="Create Workload"
        type="default"
      >
      </dx-button>
    }
  </div>
  <dx-data-grid
    (onCellPrepared)="onCellPrepared($event)"
    (onOptionChanged)="onOptionChanged($event)"
    [dataSource]="agendaDataSource"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    dataRowTemplate="dataRowTemplate"
    id="agendaContainer"
  >
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [pageSize]="pageSize"></dxo-paging>

    <dxi-column
      [allowFiltering]="false"
      [allowHeaderFiltering]="true"
      caption="Type"
      dataField="levelDesc"
    >
    </dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="PM"
      dataField="pm"
    ></dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="Code"
      dataField="resultCode"
    ></dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="Name"
      dataField="resultName"
    ></dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="Start Date"
      dataField="resultStartDate"
      dataType="date"
      [format]="'x' | calendarDate"
    >
    </dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="End Date"
      dataField="resultEndDate"
      dataType="date"
      [format]="'x' | calendarDate"
    >
    </dxi-column>
    <dxi-column
      [allowHeaderFiltering]="false"
      caption="Customer"
      dataField="resultCustomer"
    ></dxi-column>
    <dxi-column
      [allowFiltering]="false"
      [allowHeaderFiltering]="true"
      caption="Status"
      dataField="statusDesc"
    >
    </dxi-column>
    @if (showingAgenda) {
      <dxi-column
        [allowFiltering]="false"
        [allowHeaderFiltering]="true"
        caption="Planning Status"
        dataField="categoryDescription"
      >
      </dxi-column>
    }

    <ng-container *dxTemplate="let agendaRow of 'dataRowTemplate'">
      <tr class="main-row" role="row">
        <td role="gridcell">
          @if (showingAgenda) {
            @if (agendaRow.data.levelDesc == "Opportunity") {
              <em
                [id]="'notification' + agendaRow.data.id"
                class="material-symbols-outlined dx-theme-accent-as-text-color external_icon_material"
                (click)="onClickAction('wizard', agendaRow.data, true)"
              >
                work_update
              </em>
              <dx-tooltip
                [hideEvent]="{
                  name: 'dxhoverend dxclick dxremove',
                  delay: 100,
                }"
                [hideOnOutsideClick]="true"
                [target]="'#notification' + agendaRow.data.id"
                showEvent="dxhoverstart"
              >
                <div *dxTemplate="let data = data of 'content'">
                  Click to open Planning Wizard!
                </div>
              </dx-tooltip>
            } @else if (!agendaRow.data.displayed) {
              @if (agendaRow.data.levelDesc == "Opportunity") {
                <em
                  [id]="'notification' + agendaRow.data.id"
                  class="material-symbols-outlined dx-theme-accent-as-text-color external_icon_material"
                  (click)="onClickAction('wizard', agendaRow.data, true)"
                >
                  work_update
                </em>
                <dx-tooltip
                  [hideEvent]="{
                    name: 'dxhoverend dxclick dxremove',
                    delay: 100,
                  }"
                  [hideOnOutsideClick]="true"
                  [target]="'#notification' + agendaRow.data.id"
                  showEvent="dxhoverstart"
                >
                  <div *dxTemplate="let data = data of 'content'">
                    Click to open Planning Wizard!
                  </div>
                </dx-tooltip>
              } @else if (!agendaRow.data.displayed) {
                <em
                  [id]="'notification' + agendaRow.data.id"
                  class="material-symbols-outlined external_icon_material"
                  (click)="onClickAction('accept', agendaRow.data, true)"
                >
                  mail
                </em>
                <dx-tooltip
                  [hideEvent]="{
                    name: 'dxhoverend dxclick dxremove',
                    delay: 100,
                  }"
                  [hideOnOutsideClick]="true"
                  [target]="'#notification' + agendaRow.data.id"
                  showEvent="dxhoverstart"
                >
                  <div *dxTemplate="let data = data of 'content'">
                    Click to accept notification!
                  </div>
                </dx-tooltip>
              }
            }
          }
          {{ agendaRow.data.levelDesc }}
        </td>
        <td role="gridcell">
          {{ agendaRow.data.pm }}
        </td>
        <td role="gridcell">
          <em
            (click)="onClickAction('edit', agendaRow.data, false)"
            class="code_highlight"
          >
            {{ agendaRow.data.resultCode }}
          </em>
        </td>
        <td role="gridcell">
          {{ agendaRow.data.resultName }}
        </td>
        <td role="gridcell">
          {{
            (agendaRow.data.resultStartDate
              | stringToMoment).format('L')
          }}
        </td>
        <td role="gridcell">
          {{
            (agendaRow.data.resultEndDate
              | stringToMoment).format('L')
                
          }}
        </td>
        <td role="gridcell">{{ agendaRow.data.resultCustomer }}</td>
        <td role="gridcell">
          {{ agendaRow.data.statusDesc }}
        </td>
        @if (showingAgenda) {
          <td role="gridcell">
            <em
              [id]="'categoryDescription' + agendaRow.data.id"
              style="font-style: normal"
            >
              {{ agendaRow.data.categoryDescription }}
            </em>
            <dx-tooltip
              [hideEvent]="{
                name: 'dxhoverend dxclick dxremove',
                delay: 100,
              }"
              [hideOnOutsideClick]="true"
              [target]="'#categoryDescription' + agendaRow.data.id"
              showEvent="dxhoverstart"
            >
              <div *dxTemplate="let data = data of 'content'">
                {{ agendaRow.data.details }}
              </div>
            </dx-tooltip>
          </td>
        }
      </tr>
    </ng-container>
  </dx-data-grid>
</div>

<app-create-workload-modal
  (closeModalEmitter)="onCloseModal($event)"
  [isPopupVisible]="isPopupVisible"
>
</app-create-workload-modal>
<app-planning-wizard
  [isPopupVisible]="isWizardVisible"
  [figures]="figures"
  [geos]="geos"
  [practices]="practices"
  [disciplines]="disciplines"
  [startDate]="wizardStartDate"
  [endDate]="wizardEndDate"
  [agreementId]="wizardAgreementId"
  [opportunityId]="wizardOpportunityId"
  [pep]="wizardPep"
  (closeModalEmitter)="onCloseWizard($event)"
>
</app-planning-wizard>
